"use client";
import { j as C } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as lt } from "./tv.config-BuYIgndg.mjs";
import { s as ft } from "./ChevronDownIcon-ALVrcZU5.mjs";
import * as e from "react";
import * as pt from "react-dom";
import { u as re } from "./useTimeout-BRUciAq6.mjs";
import { u as me } from "./useEventCallback-CjuAhyNz.mjs";
import { u as dt } from "./useControlled-B2rPEZCb.mjs";
import { u as mt } from "./useId-CFOlRH4L.mjs";
import { u as ie, M as gt } from "./MenuRootContext-BxTmYndK.mjs";
import { a as He, u as yt } from "./useOpenChangeComplete-CXAVaIGe.mjs";
import { u as ye, f as xt, E as _e, D as Mt, P as bt, T as Rt, m as je, c as Et } from "./useRenderElement-B8V3_e8R.mjs";
import { u as Ct } from "./DirectionContext-D4ZBZehF.mjs";
import { F as ht, I as vt, u as Pt, a as wt } from "./useScrollLock-COQT0_go.mjs";
import { u as Tt } from "./useOpenInteractionType-CFukK4P5.mjs";
import { t as Ot, u as Nt, a as St, b as It } from "./translateOpenChangeReason-C857LgAi.mjs";
import { o as ge } from "./owner-DpSCkBia.mjs";
import { c as kt, u as Dt } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { u as At, s as Ft } from "./safePolygon-9xumQ2iN.mjs";
import { k as Lt, a as Ae, c as Be, d as Ht, e as _t } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import { e as jt, b as Bt } from "./detectBrowser-CpuomNQW.mjs";
import { e as Fe, c as ce, g as Ut, m as Vt, n as Yt, f as Kt } from "./element-DE7VsBMX.mjs";
import { u as Wt, a as Xt, g as qt } from "./getPseudoElementBounds-D3t2tvmN.mjs";
import { u as xe, d as Gt, a as Jt, F as zt, b as Qt } from "./FloatingTree-vWe5pGqE.mjs";
import { p as Ue, a as Le } from "./popupStateMapping-Cl0RMVD6.mjs";
import { u as Zt } from "./useButton-CQeWQM5o.mjs";
import { C as $t } from "./CompositeItem-DhB3Tdag.mjs";
import { F as en } from "./FloatingPortal-B6chGyBH.mjs";
import { i as tn } from "./inertValue-CseOXFGF.mjs";
import { u as nn } from "./useAnchorPositioning-DZydZPwe.mjs";
import { C as on } from "./CompositeList-BwSEPM9t.mjs";
import { t as sn } from "./useAnimationsFinished-DDpUuXkZ.mjs";
const rn = lt({
  slots: {
    root: "Menu__root ",
    trigger: [
      "flex h-10 items-center justify-center gap-1.5  px-3.5  select-none  focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800"
    ],
    popup: [
      "origin-[var(--transform-origin)] rounded-md bg-[canvas] py-1 text-gray-900  outline outline-1 outline-gray-300 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0  dark:-outline-offset-1 dark:outline-gray-300 max-h-[300px] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
    ],
    portal: [""],
    positioner: ["outline-none"],
    icon: ["-mr-1"]
  },
  variants: {}
}), {
  root: Zn,
  trigger: un,
  popup: an,
  portal: $n,
  positioner: cn,
  icon: ln
} = rn(), Me = /* @__PURE__ */ e.createContext(void 0);
process.env.NODE_ENV !== "production" && (Me.displayName = "MenuPositionerContext");
function fn() {
  const o = e.useContext(Me);
  if (o === void 0)
    throw new Error("Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>.");
  return o;
}
const Ve = /* @__PURE__ */ e.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ve.displayName = "ContextMenuRootContext");
function Ye(o = !0) {
  const s = e.useContext(Ve);
  if (s === void 0 && !o)
    throw new Error("Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>.");
  return s;
}
const de = jt && Bt;
function pn(o, s = {}) {
  const {
    open: y,
    onOpenChange: x,
    events: p,
    dataRef: d,
    elements: M
  } = o, {
    enabled: u = !0,
    visibleOnly: S = !0
  } = s, P = e.useRef(!1), I = re(), b = e.useRef(!0);
  e.useEffect(() => {
    if (!u)
      return;
    const r = Lt(M.domReference);
    function n() {
      !y && Be(M.domReference) && M.domReference === Fe(Kt(M.domReference)) && (P.current = !0);
    }
    function R() {
      b.current = !0;
    }
    function T() {
      b.current = !1;
    }
    return r.addEventListener("blur", n), de && (r.addEventListener("keydown", R, !0), r.addEventListener("pointerdown", T, !0)), () => {
      r.removeEventListener("blur", n), de && (r.removeEventListener("keydown", R, !0), r.removeEventListener("pointerdown", T, !0));
    };
  }, [M.domReference, y, u]), e.useEffect(() => {
    if (!u)
      return;
    function r({
      reason: n
    }) {
      (n === "reference-press" || n === "escape-key") && (P.current = !0);
    }
    return p.on("openchange", r), () => {
      p.off("openchange", r);
    };
  }, [p, u]);
  const w = e.useMemo(() => ({
    onMouseLeave() {
      P.current = !1;
    },
    onFocus(r) {
      if (P.current)
        return;
      const n = Ut(r.nativeEvent);
      if (S && Ae(n)) {
        if (de && !r.relatedTarget) {
          if (!b.current && !Vt(n))
            return;
        } else if (!Yt(n))
          return;
      }
      x(!0, r.nativeEvent, "focus");
    },
    onBlur(r) {
      P.current = !1;
      const n = r.relatedTarget, R = r.nativeEvent, T = Ae(n) && n.hasAttribute(kt("focus-guard")) && n.getAttribute("data-type") === "outside";
      I.start(0, () => {
        var a;
        const O = Fe(M.domReference ? M.domReference.ownerDocument : document);
        !n && O === M.domReference || ce((a = d.current.floatingContext) == null ? void 0 : a.refs.floating.current, O) || ce(M.domReference, O) || T || x(!1, R, "focus");
      });
    }
  }), [d, M.domReference, x, S, I]);
  return e.useMemo(() => u ? {
    reference: w
  } : {}, [u, w]);
}
const dn = {
  ...Ue,
  ...sn
}, Ke = /* @__PURE__ */ e.forwardRef(function(s, y) {
  const {
    render: x,
    className: p,
    finalFocus: d,
    ...M
  } = s, {
    open: u,
    setOpen: S,
    popupRef: P,
    transitionStatus: I,
    popupProps: b,
    mounted: w,
    instantType: r,
    onOpenChangeComplete: n,
    parent: R,
    lastOpenChangeReason: T,
    rootId: O
  } = ie(), {
    side: a,
    align: D,
    floatingContext: H
  } = fn();
  He({
    open: u,
    ref: P,
    onComplete() {
      u && (n == null || n(!0));
    }
  });
  const {
    events: k
  } = xe();
  e.useEffect(() => {
    function N(F) {
      S(!1, F.domEvent, F.reason);
    }
    return k.on("close", N), () => {
      k.off("close", N);
    };
  }, [k, S]);
  const _ = e.useMemo(() => ({
    transitionStatus: I,
    side: a,
    align: D,
    open: u,
    nested: R.type === "menu",
    instant: r
  }), [I, a, D, u, R.type, r]), A = ye("div", s, {
    state: _,
    ref: [y, P],
    customStyleHookMapping: dn,
    props: [b, I === "starting" ? xt : _e, M, {
      "data-rootownerid": O
    }]
  });
  let m = R.type === void 0 || R.type === "context-menu";
  return R.type === "menubar" && T !== "outside-press" && (m = !0), /* @__PURE__ */ C.jsx(ht, {
    context: H,
    modal: !1,
    disabled: !w,
    returnFocus: d || m,
    initialFocus: R.type === "menu" ? -1 : 0,
    restoreFocus: !0,
    children: A
  });
});
process.env.NODE_ENV !== "production" && (Ke.displayName = "MenuPopup");
const be = /* @__PURE__ */ e.createContext(void 0);
process.env.NODE_ENV !== "production" && (be.displayName = "MenuPortalContext");
function mn() {
  const o = e.useContext(be);
  if (o === void 0)
    throw new Error("Base UI: <Menu.Portal> is missing.");
  return o;
}
function gn(o) {
  const {
    children: s,
    keepMounted: y = !1,
    container: x
  } = o, {
    mounted: p
  } = ie();
  return p || y ? /* @__PURE__ */ C.jsx(be.Provider, {
    value: y,
    children: /* @__PURE__ */ C.jsx(en, {
      root: x,
      children: s
    })
  }) : null;
}
const We = /* @__PURE__ */ e.forwardRef(function(s, y) {
  var ne;
  const {
    anchor: x,
    positionMethod: p = "absolute",
    className: d,
    render: M,
    side: u,
    align: S,
    sideOffset: P = 0,
    alignOffset: I = 0,
    collisionBoundary: b = "clipping-ancestors",
    collisionPadding: w = 5,
    arrowPadding: r = 5,
    sticky: n = !1,
    trackAnchor: R = !0,
    collisionAvoidance: T = Mt,
    ...O
  } = s, {
    open: a,
    setOpen: D,
    floatingRootContext: H,
    setPositionerElement: k,
    itemDomElements: _,
    itemLabels: A,
    mounted: m,
    modal: N,
    lastOpenChangeReason: F,
    parent: f,
    setHoverEnabled: K,
    triggerElement: W
  } = ie(), oe = mn(), g = Gt(), E = Jt(), L = Ye(!0);
  let Z = x, G = P, $ = I, ee = S;
  f.type === "context-menu" && (Z = ((ne = f.context) == null ? void 0 : ne.anchor) ?? x, ee = s.align ?? "start", $ = s.alignOffset ?? 2, G = s.sideOffset ?? -5);
  let j = u, J = ee;
  f.type === "menu" ? (j = j ?? "inline-end", J = J ?? "start") : f.type === "menubar" && (j = j ?? "bottom", J = J ?? "start");
  const t = f.type === "context-menu", c = nn({
    anchor: Z,
    floatingRootContext: H,
    positionMethod: L ? "fixed" : p,
    mounted: m,
    side: j,
    sideOffset: G,
    align: J,
    alignOffset: $,
    arrowPadding: t ? 0 : r,
    collisionBoundary: b,
    collisionPadding: w,
    sticky: n,
    nodeId: g,
    keepMounted: oe,
    trackAnchor: R,
    collisionAvoidance: T,
    shiftCrossAxis: t
  }), {
    events: B
  } = xe(), te = e.useMemo(() => {
    const q = {};
    return a || (q.pointerEvents = "none"), {
      role: "presentation",
      hidden: !m,
      style: {
        ...c.positionerStyles,
        ...q
      }
    };
  }, [a, m, c.positionerStyles]);
  e.useEffect(() => {
    function q(V) {
      V.open ? (V.parentNodeId === g && K(!1), V.nodeId !== g && V.parentNodeId === E && D(!1, void 0, "sibling-open")) : V.parentNodeId === g && K(!0);
    }
    return B.on("openchange", q), () => {
      B.off("openchange", q);
    };
  }, [B, g, E, D, K]), e.useEffect(() => {
    B.emit("openchange", {
      open: a,
      nodeId: g,
      parentNodeId: E
    });
  }, [B, a, g, E]);
  const U = e.useMemo(() => ({
    open: a,
    side: c.side,
    align: c.align,
    anchorHidden: c.anchorHidden,
    nested: f.type === "menu"
  }), [a, c.side, c.align, c.anchorHidden, f.type]), X = e.useMemo(() => ({
    side: c.side,
    align: c.align,
    arrowRef: c.arrowRef,
    arrowUncentered: c.arrowUncentered,
    arrowStyles: c.arrowStyles,
    floatingContext: c.context
  }), [c.side, c.align, c.arrowRef, c.arrowUncentered, c.arrowStyles, c.context]), l = ye("div", s, {
    state: U,
    customStyleHookMapping: Ue,
    ref: [y, k],
    props: {
      ...te,
      ...O
    }
  }), le = m && f.type !== "menu" && (f.type !== "menubar" && N && F !== "trigger-hover" || f.type === "menubar" && f.context.modal);
  let z = null;
  return f.type === "menubar" ? z = f.context.contentElement : f.type === void 0 && (z = W), /* @__PURE__ */ C.jsxs(Me.Provider, {
    value: X,
    children: [le && /* @__PURE__ */ C.jsx(vt, {
      ref: f.type === "context-menu" || f.type === "nested-context-menu" ? f.context.internalBackdropRef : null,
      inert: tn(!a),
      cutout: z
    }), /* @__PURE__ */ C.jsx(zt, {
      id: g,
      children: /* @__PURE__ */ C.jsx(on, {
        elementsRef: _,
        labelsRef: A,
        children: l
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (We.displayName = "MenuPositioner");
const Xe = /* @__PURE__ */ e.createContext(null);
process.env.NODE_ENV !== "production" && (Xe.displayName = "MenubarContext");
function yn(o) {
  return e.useContext(Xe);
}
const qe = /* @__PURE__ */ e.createContext(!1);
process.env.NODE_ENV !== "production" && (qe.displayName = "MenuSubmenuRootContext");
function xn() {
  return e.useContext(qe);
}
function Mn(o) {
  const {
    enabled: s = !0,
    mouseDownAction: y,
    open: x
  } = o, p = e.useRef(!1);
  return e.useMemo(() => s ? {
    onMouseDown: (d) => {
      (y === "open" && !x || y === "close" && x) && (p.current = !0, ge(d.currentTarget).addEventListener("click", () => {
        p.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (d) => {
      p.current && (p.current = !1, d.preventBaseUIHandler());
    }
  } : _e, [s, y, x]);
}
const bn = [], Rn = {
  current: !1
}, En = function(s) {
  const {
    children: y,
    open: x,
    onOpenChange: p,
    onOpenChangeComplete: d,
    defaultOpen: M = !1,
    disabled: u = !1,
    modal: S,
    loop: P = !0,
    orientation: I = "vertical",
    actionsRef: b,
    openOnHover: w,
    delay: r = 100,
    closeDelay: n = 0,
    closeParentOnEsc: R = !0
  } = s, [T, O] = e.useState(null), [a, D] = e.useState(null), [H, k] = e.useState(), [_, A] = e.useState(!0), [m, N] = e.useState(null), [F, f] = e.useState(null), [K, W] = e.useState(!0), [oe, g] = e.useState(!1), E = e.useRef(null), L = e.useRef(null), Z = e.useRef(null), G = e.useRef([]), $ = e.useRef([]), ee = re(), j = Ye(!0), J = xn();
  let t;
  {
    const i = ie(!0), h = yn();
    J && i ? t = {
      type: "menu",
      context: i
    } : h ? t = {
      type: "menubar",
      context: h
    } : j ? t = {
      type: "context-menu",
      context: j
    } : t = {
      type: void 0
    };
  }
  let c = mt();
  t.type !== void 0 && (c = t.context.rootId);
  const B = (t.type === void 0 || t.type === "context-menu") && (S ?? !0), te = t.type === "menu" ? t.context.allowMouseEnter : oe, U = t.type === "menu" ? t.context.setAllowMouseEnter : g;
  process.env.NODE_ENV !== "production" && t.type !== void 0 && S !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored.");
  const X = w ?? (t.type === "menu" || t.type === "menubar" && t.context.hasSubmenuOpen), [l, le] = dt({
    controlled: x,
    default: M,
    name: "MenuRoot",
    state: "open"
  }), z = e.useRef(t.type !== "context-menu"), ne = re();
  e.useEffect(() => {
    if (l || (E.current = null), t.type === "context-menu") {
      if (!l) {
        ne.clear(), z.current = !1;
        return;
      }
      ne.start(500, () => {
        z.current = !0;
      });
    }
  }, [ne, l, t.type]);
  const q = e.useCallback((i) => {
    Z.current = i, D(i);
  }, []), {
    mounted: V,
    setMounted: ze,
    transitionStatus: Re
  } = yt(l), {
    openMethod: Qe,
    triggerProps: Ee,
    reset: Ze
  } = Tt(l);
  Pt({
    enabled: l && B && F !== "trigger-hover" && Qe !== "touch",
    mounted: V,
    open: l,
    referenceElement: a
  }), !l && !_ && A(!0);
  const fe = me(() => {
    ze(!1), W(!0), U(!1), d == null || d(!1), Ze();
  });
  He({
    enabled: !b,
    open: l,
    ref: L,
    onComplete() {
      l || fe();
    }
  });
  const ue = e.useRef(!0), Ce = re(), se = me((i, h, v) => {
    if (l === i || i === !1 && (h == null ? void 0 : h.type) === "click" && h.pointerType === "touch" && !ue.current)
      return;
    if (!i && m !== null) {
      const pe = G.current[m];
      queueMicrotask(() => {
        pe == null || pe.setAttribute("tabindex", "-1");
      });
    }
    i && v === "trigger-focus" ? (ue.current = !1, Ce.start(300, () => {
      ue.current = !0;
    })) : (ue.current = !0, Ce.clear());
    const ke = (v === "trigger-press" || v === "item-press") && h.detail === 0 && (h == null ? void 0 : h.isTrusted), ct = !i && (v === "escape-key" || v == null);
    function De() {
      p == null || p(i, h, v), le(i), f(v ?? null), E.current = h ?? null;
    }
    v === "trigger-hover" ? (W(!0), ee.start(bt, () => {
      W(!1);
    }), pt.flushSync(De)) : De(), t.type === "menubar" && (v === "trigger-focus" || v === "focus-out" || v === "trigger-hover" || v === "list-navigation" || v === "sibling-open") ? k("group") : k(ke || ct ? ke ? "click" : "dismiss" : void 0);
  });
  e.useImperativeHandle(b, () => ({
    unmount: fe
  }), [fe]);
  let Q;
  t.type === "context-menu" && (Q = t.context), e.useImperativeHandle(Q == null ? void 0 : Q.positionerRef, () => a, [a]), e.useImperativeHandle(Q == null ? void 0 : Q.actionsRef, () => ({
    setOpen: se
  }), [se]), e.useEffect(() => {
    l || ee.clear();
  }, [ee, l]);
  const Y = Dt({
    elements: {
      reference: T,
      floating: a
    },
    open: l,
    onOpenChange(i, h, v) {
      se(i, h, Ot(v));
    }
  }), $e = At(Y, {
    enabled: _ && X && !u && t.type !== "context-menu" && (t.type !== "menubar" || t.context.hasSubmenuOpen && !l),
    handleClose: Ft({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: t.type === "menu",
    restMs: t.type === void 0 || t.type === "menu" && te ? r : void 0,
    delay: t.type === "menu" ? {
      open: te ? r : 10 ** 10,
      close: n
    } : {
      close: n
    }
  }), et = pn(Y, {
    enabled: !u && !l && t.type === "menubar" && t.context.hasSubmenuOpen && !j
  }), tt = Nt(Y, {
    enabled: !u && t.type !== "context-menu",
    event: l && t.type === "menubar" ? "click" : "mousedown",
    toggle: !X || t.type !== "menu",
    ignoreMouse: X && t.type === "menu",
    stickIfOpen: t.type === void 0 ? K : !1
  }), nt = St(Y, {
    enabled: !u,
    bubbles: R && t.type === "menu",
    outsidePress() {
      var i;
      return t.type !== "context-menu" || ((i = E.current) == null ? void 0 : i.type) === "contextmenu" ? !0 : z.current;
    }
  }), ot = wt(Y, {
    role: "menu"
  }), st = Ct(), rt = Wt(Y, {
    enabled: !u,
    listRef: G,
    activeIndex: m,
    nested: t.type !== void 0,
    loop: P,
    orientation: I,
    parentOrientation: t.type === "menubar" ? t.context.orientation : void 0,
    rtl: st === "rtl",
    disabledIndices: bn,
    onNavigate: N,
    openOnArrowKeyDown: t.type !== "context-menu"
  }), he = e.useRef(!1), it = e.useCallback((i) => {
    he.current = i;
  }, []), ut = Xt(Y, {
    listRef: $,
    activeIndex: m,
    resetMs: Rt,
    onMatch: (i) => {
      l && i !== m && N(i);
    },
    onTypingChange: it
  }), {
    getReferenceProps: ve,
    getFloatingProps: Pe,
    getItemProps: we
  } = It([$e, tt, nt, et, ot, rt, ut]), Te = Mn({
    open: l,
    enabled: t.type === "menubar",
    mouseDownAction: "open"
  }), Oe = e.useMemo(() => {
    const i = je(ve(), {
      onMouseEnter() {
        A(!0);
      },
      onMouseMove() {
        U(!0);
      }
    }, Ee, Te);
    return delete i.role, i;
  }, [ve, Te, U, Ee]), Ne = e.useMemo(() => Pe({
    onMouseEnter() {
      (!X || t.type === "menu") && A(!1);
    },
    onMouseMove() {
      U(!0);
    },
    onClick() {
      X && A(!1);
    }
  }), [Pe, X, t.type, U]), Se = e.useMemo(() => we(), [we]), at = e.useMemo(() => ({
    activeIndex: m,
    setActiveIndex: N,
    allowMouseUpTriggerRef: t.type ? t.context.allowMouseUpTriggerRef : Rn,
    floatingRootContext: Y,
    itemProps: Se,
    popupProps: Ne,
    triggerProps: Oe,
    itemDomElements: G,
    itemLabels: $,
    mounted: V,
    open: l,
    popupRef: L,
    positionerRef: Z,
    setOpen: se,
    setPositionerElement: q,
    triggerElement: T,
    setTriggerElement: O,
    transitionStatus: Re,
    lastOpenChangeReason: F,
    instantType: H,
    onOpenChangeComplete: d,
    setHoverEnabled: A,
    typingRef: he,
    modal: B,
    disabled: u,
    parent: t,
    rootId: c,
    allowMouseEnter: te,
    setAllowMouseEnter: U
  }), [m, Y, Se, Ne, Oe, G, $, V, l, Z, se, Re, T, q, F, H, d, B, u, t, c, te, U]), Ie = /* @__PURE__ */ C.jsx(gt.Provider, {
    value: at,
    children: y
  });
  return t.type === void 0 || t.type === "context-menu" ? /* @__PURE__ */ C.jsx(Qt, {
    children: Ie
  }) : Ie;
}, ae = 2, Ge = /* @__PURE__ */ e.forwardRef(function(s, y) {
  const {
    render: x,
    className: p,
    disabled: d = !1,
    nativeButton: M = !0,
    ...u
  } = s, {
    triggerProps: S,
    disabled: P,
    setTriggerElement: I,
    open: b,
    allowMouseUpTriggerRef: w,
    positionerRef: r,
    parent: n,
    lastOpenChangeReason: R,
    rootId: T
  } = ie(), O = d || P, a = e.useRef(null), D = re(), {
    getButtonProps: H,
    buttonRef: k
  } = Zt({
    disabled: O,
    native: M
  }), _ = Et(k, I), {
    events: A
  } = xe();
  e.useEffect(() => {
    !b && n.type === void 0 && (w.current = !1);
  }, [w, b, n.type]);
  const m = me((g) => {
    if (!a.current)
      return;
    D.clear(), w.current = !1;
    const E = g.target;
    if (ce(a.current, E) || ce(r.current, E) || E === a.current || E != null && Je(E) === T)
      return;
    const L = qt(a.current);
    g.clientX >= L.left - ae && g.clientX <= L.right + ae && g.clientY >= L.top - ae && g.clientY <= L.bottom + ae || A.emit("close", {
      domEvent: g,
      reason: "cancel-open"
    });
  });
  e.useEffect(() => {
    b && R === "trigger-hover" && ge(a.current).addEventListener("mouseup", m, {
      once: !0
    });
  }, [b, m, R]);
  const N = n.type === "menubar", F = e.useCallback((g) => je(N ? {
    role: "menuitem"
  } : {}, {
    "aria-haspopup": "menu",
    ref: _,
    onMouseDown: (E) => {
      if (b)
        return;
      D.start(200, () => {
        w.current = !0;
      }), ge(E.currentTarget).addEventListener("mouseup", m, {
        once: !0
      });
    }
  }, g, H), [H, _, b, w, D, m, N]), f = e.useMemo(() => ({
    disabled: O,
    open: b
  }), [O, b]), K = [a, y, k], W = [S, u, F], oe = ye("button", s, {
    enabled: !N,
    customStyleHookMapping: Le,
    state: f,
    ref: K,
    props: W
  });
  return N ? /* @__PURE__ */ C.jsx($t, {
    tag: "button",
    render: x,
    className: p,
    state: f,
    refs: K,
    props: W,
    customStyleHookMapping: Le
  }) : oe;
});
process.env.NODE_ENV !== "production" && (Ge.displayName = "MenuTrigger");
function Je(o) {
  if (Be(o) && o.hasAttribute("data-rootownerid"))
    return o.getAttribute("data-rootownerid") ?? void 0;
  if (!Ht(o))
    return Je(_t(o));
}
const eo = (o) => {
  const {
    children: s,
    className: y,
    label: x,
    component: p = "button",
    title: d,
    align: M,
    ...u
  } = o;
  return /* @__PURE__ */ C.jsxs(En, { ...u, children: [
    /* @__PURE__ */ C.jsxs(
      Ge,
      {
        type: "button",
        className: un({ className: y }),
        title: d,
        children: [
          x,
          " ",
          /* @__PURE__ */ C.jsx(ft, { className: ln() })
        ]
      }
    ),
    /* @__PURE__ */ C.jsx(gn, { children: /* @__PURE__ */ C.jsx(
      We,
      {
        align: M,
        className: cn(),
        sideOffset: 8,
        sticky: !0,
        children: /* @__PURE__ */ C.jsx(Ke, { className: an(), children: s })
      }
    ) })
  ] });
};
export {
  eo as default
};
